import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import {
  copyToClipboard,
  formatDateInAMPM,
  trimAddress,
} from "../../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { BASE_URL, STANDARD_IMAGE_URL } from "../../utils/constant";
import AddNftCollection from "../model/AddNftCollection";

const NftCollectionsLayer = () => {
  const { AsyncGetApiCall, AsyncPostApiCall, AsyncDeleteApiCall } = useApi();
  const navigate = useNavigate();
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [modalData, setModalData] = useState({});

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
  };

  const handleModalClose = (shouldRefresh = false) => {
    setShowModal(false);
    setModalData(null);
    if (shouldRefresh) getAllNftCollectionsList();
  };

  const getAllNftCollectionsList = async (showLoader = true) => {
    try {
      if (showLoader) {
        setLoading(true);
      }
      console.log("query...", query);
      const result = await AsyncGetApiCall("/collection/filter-list", query);
      console.log("Resulst:", result);

      if (result?.success) {
        setData(result || []);
      } else {
        toast.error(result?.message || "Failed to fetch collection data");
      }
    } catch (error) {
      console.log("error...", error);
      toast.error("An error occurred while fetching collection data");
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  const handleSearchAirdrop = (e) => {
    const value = e.target.value;
    const validChars = /^[a-zA-Z0-9]*$/; // Only alphanumeric characters allowed

    if (validChars.test(value)) {
      setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setQuery((prev) => ({
      ...prev,
      status: value === "Select Status" ? "" : value,
      pageNo: 1,
    }));
  };

  const handleActivateCollection = async (address, isActive) => {
    // console.log("id...", id);
    console.log("isActive...", isActive);

    try {
      setLoading(true);
      const payload = {
        // collectionId: id,
        collectionAddress: address,
        status: isActive,
      };
      const result = await AsyncPostApiCall(
        `/collection/status-management`,
        payload
      );
      console.log("result...", result);
      if (result?.success) {
        toast.success(
          result?.message ||
            `Collection ${
              result?.data?.isActive ? "activated" : "deactivated"
            } successfully`
        );
        getAllNftCollectionsList(false);
      } else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (error) {
      console.log("error...", error);
      toast.error("An error occurred while updating collection status");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllNftCollectionsList(true);
  }, [query]);

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <span className="text-md fw-medium text-secondary-light mb-0">
                Show
              </span>
              <select
                className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                value={query.limitVal}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  setQuery((prev) => ({
                    ...prev,
                    limitVal: value,
                    pageNo: 1,
                  }));
                }}>
                {Array.from({ length: 20 }, (_, i) => {
                  const value = (i + 1) * 5;
                  return (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  );
                })}
              </select>
            </div>

            <div>
              {/* Add button */}
              <button
                type="button"
                className="btn btn-primary-600 radius-8 px-17 py-9 d-flex align-items-center gap-2 ms-auto"
                onClick={() => {
                  setModalMode("create");
                  setModalData(null);
                  setShowModal(true);
                }}
                disabled={loading}>
                <Icon
                  icon="ic:outline-collections"
                  className="menu-icon"
                  width="24"
                  height="24"
                />
                Create Collection
              </button>
            </div>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.No
                    </div>
                  </th>
                  <th scope="col">Name</th>
                  <th scope="col">Address</th>
                  <th scope="col">Category</th>

                  <th scope="col">Date</th>
                  <th scope="col">Status</th>
                  <th scope="col" className="text-center">
                    Activate
                  </th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data && data?.data?.length > 0 ? (
                  data?.data?.map((collection, index) => (
                    <tr key={collection._id}>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-10">
                          {(data?.currentPage - 1) * query.limitVal + index + 1}
                        </div>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {collection?.image && (
                            <img
                              src={
                                collection?.image
                                  ? collection?.image
                                  : STANDARD_IMAGE_URL
                              }
                              alt="NFT"
                              className="w-40-px h-40-px flex-shrink-0 me-12 overflow-hidden nft-border-radius"
                            />
                          )}
                          {collection?.name}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {trimAddress(collection?.address, 6, 6)}
                          <button
                            onClick={() => copyToClipboard(collection?.address)}
                            className="ms-3 p-0 border-0 bg-transparent"
                            style={{ lineHeight: 1 }}>
                            <IoCopyOutline />
                          </button>
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {collection?.category}
                        </span>
                      </td>

                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {formatDateInAMPM(collection?.createdAt)}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            collection?.isActive
                              ? "bg-success-100 text-success-600"
                              : "bg-danger-100 text-danger-600"
                          } text-sm py-4 px-10 radius-4`}>
                          {collection?.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`toggle-${collection._id}`}
                              checked={collection?.isActive}
                              onChange={() => {
                                if (
                                  window.confirm(
                                    "Are you sure you want to change the status of this collection?"
                                  )
                                ) {
                                  handleActivateCollection(
                                    collection?.address,
                                    !collection?.isActive
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() =>
                              navigate(
                                `/view-nft-collection/${collection?.address}`
                              )
                            }>
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                            <span className="tooltip-text">View</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No collections found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.total || 0}
            totalPages={data?.totalPages || 0}
            currentPage={data?.currentPage || 0}
            setPageNo={setPageNo}
            startFrom={(data?.currentPage - 1) * query.limitVal + 1}
            endTo={
              (data?.currentPage - 1) * query.limitVal +
              (data?.data?.length || 0)
            }
          />

          <AddNftCollection
            show={showModal}
            handleClose={handleModalClose}
            mode={modalMode}
            data={modalData}
          />
        </div>
      </div>
    </>
  );
};

export default NftCollectionsLayer;
